import { FC, useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import * as React from 'react'
import { Button } from 'src/components'
import { useTheme } from '@mui/material/styles'

interface Props {
  id: string
  show: boolean
  title: string
  description?: string | React.ReactNode
  handleClose: () => void
  handleConfirm: (id: string | boolean) => void
  isPrompt?: boolean
  confimButtonColor?: string
  confrimText?: string
  cancelText?: string
}
/**
 * Based on MUI Dialog. Accepts callback in case of cancel/confirm.
 * @returns
 */
const ConfirmModal: FC<Props> = ({
  id,
  show,
  title,
  description,
  handleClose,
  handleConfirm,
  isPrompt,
  confimButtonColor,
  confrimText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  const theme = useTheme()
  const [open, setOpen] = React.useState(show)

  const _handleClose = () => {
    setOpen(false)
    handleClose()
  }

  const _handleConfirm = (confirmed?: boolean) => {
    setOpen(false)
    //@ts-ignore
    isPrompt ? handleConfirm(confirmed) : handleConfirm(id)
  }
  useEffect(() => {
    setOpen(show)
  }, [show])
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          variant="body1"
          color="black"
        >
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          textColor={theme.palette.text.primary}
          onClick={
            isPrompt
              ? () => {
                  _handleConfirm(false)
                }
              : _handleClose
          }
        >
          {cancelText}
        </Button>
        <Button
          textColor={theme.palette.common.white}
          // backgroundColor="#f44336"
          backgroundColor={
            confimButtonColor ? confimButtonColor : theme.palette.error.main
          }
          //@ts-ignore
          onClick={
            isPrompt
              ? () => {
                  _handleConfirm(true)
                }
              : _handleConfirm
          }
        >
          {confrimText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmModal
